<template>
	<div class="c-app" :class="{ 'c-dark-theme': $store.state.darkMode }">
		<TheSidebar />
		<CWrapper>
			<TheHeader
				:breadcrumbs="breadcrumbs"
				:page-title="pageTitle"
			/>
			<div
				ref="c-body"
				:class="[
					'c-body',
					cBodyClass
				]"
				@scroll="handleScroll"
			>
				<main class="c-main">
					<CContainer fluid>
						<transition name="fade" mode="out-in">
							<router-view />
						</transition>
					</CContainer>
				</main>
			</div>
		</CWrapper>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import TheSidebar from './TheSidebar.vue';
import TheHeader from './TheHeader.vue';

export default {
	name: 'TheContainer',
	components: {
		TheSidebar,
		TheHeader,
	},

	computed: {
		...mapState('pageTitle', {
			showStatePageTitle: 'isShow',
			pageTitleState: 'title',
		}),
		...mapState('breadcrumb', {
			breadcrumbs: 'items',
		}),
		...mapState('app', {
			cBodyClass: 'cBodyClass',
		}),
		pageTitle() {
			if (this.showStatePageTitle) {
				return this.pageTitleState || this.$route.meta.pageTitle;
			}
			return this.$route.meta.pageTitle || '';
		},
	},

	watch: {
		$route() {
			this.setCssVariable(0); // set css varible for 0px
			this.$refs['c-body'].scrollTo(0, 0); // always scroll to top left at 0 position

			// set breadcrumbs every times when route was changed.
			this.setBreadcrumbs(this.$route.meta.breadcrumbs);
		},
	},

	created() {
		// set breadcrumbs when page is refresh.
		this.setBreadcrumbs(this.$route.meta.breadcrumbs);
	},

	methods: {
		...mapActions('breadcrumb', {
			setBreadcrumbs: 'setBreadcrumbs',
		}),
		handleScroll(e) {
			this.setCssVariable(e.target.scrollLeft);
		},
		setCssVariable(value = 0) {
			// set css variable to body element
			const el = document.querySelector('body');
			const cssVariableName = '--body-scroll-left';
			const cssValue = `${value}px`;
			el.style.setProperty(cssVariableName, cssValue);
		},
	},
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>

<style lang="scss">
// declare this class as a global
// if we want to let that element sticky with body
// then add this class to the element
.sticky-with-body-scroll-left {
	position: relative;
	top: 0;
	left: var(--body-scroll-left); // set left following from body scrollbar left
}
</style>
